import Switch from '@mui/material/Switch';
import useController from './useController';

export const ActiveSwitch = () => {
  const { isActive, toggleActive } = useController();

  return <Switch checked={isActive} onChange={toggleActive} name="switch" />;
};

export default ActiveSwitch;
